import React from "react";
import { Box, Typography } from "@material-ui/core";

export const OrderDetailsItem = ({
  title,
  label,
  hasItalicLabel,
  maxWidth,
  style,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      maxWidth={maxWidth ? maxWidth : "none"}
      style={style ? style : {}}
    >
      <Typography style={{ fontSize: 10, fontWeight: "400" }}>
        {title}
      </Typography>
      <Typography
        style={{
          fontSize: 12,
          fontWeight: "500",
          fontStyle: hasItalicLabel ? "italic" : "normal",
          width: "100%",
          textOverflow: "ellipsis",
          overflow: "hidden",
        }}
        title={label}
      >
        {label}
      </Typography>
    </Box>
  );
};
